module.exports = __webpack_public_path__ + "static/media/user_icon.f0b8c33a.svg";